const observer = new MutationObserver(() => {
  if (document.querySelector('#cancel')) {
    document.querySelector('#cancel').addEventListener("click", function() {
      document.querySelector(".sca-p-popup-main-container.sca-modal-pu.sca-is-visible-pu").classList.remove('sca-is-visible-pu')
    });
  }
});

observer.observe(document.body, {
  subtree: true,
  childList: true,
});

if (window.Shopify.country !== "JP" || window.location.search.includes("lpu=0")) {
  var css = '#sca-p-popup-main-popup-container.sca-modal-pu.sca-is-visible-pu.sca-p-popup-main-container { visibility: hidden !important; } #sca-p-popup-tab.sca-p-popup-main-container.sca-modal-pu { visibility: hidden !important;}';
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  head.appendChild(style);
}
